// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaMessageVideo__video-container-e11365 {
  position: relative;
  user-select: none;
}

.MediaMessageVideo__video-container-e11365:hover .MediaMessageVideo__delete-db5a15 {
  opacity: 1;
}

.MediaMessageVideo__video-e98b2e {
  max-width: 100%;
  height: auto;
  max-height: 392px;
  border-radius: 16px;
}

.MediaMessageVideo__icon-container-a43b14 {
  border-radius: 50%;
  background-color: var(--color-basic-5);
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.MediaMessageVideo__icon-bfc0be {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/ItemMedia/MediaMessageVideo/MediaMessageVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AACA;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,wBAAA;AAEF","sourcesContent":[".video-container {\n  position: relative;\n  user-select: none;\n}\n\n.video-container:hover .delete {\n  opacity: 1;\n}\n\n.video {\n  max-width: 100%;\n  height: auto;\n  max-height: 392px;\n  border-radius: 16px;\n}\n.icon-container {\n  border-radius: 50%;\n  background-color: var(--color-basic-5);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 48px;\n  height: 48px;\n  transform: translate(-50%, -50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-container": `MediaMessageVideo__video-container-e11365`,
	"videoContainer": `MediaMessageVideo__video-container-e11365`,
	"delete": `MediaMessageVideo__delete-db5a15`,
	"video": `MediaMessageVideo__video-e98b2e`,
	"icon-container": `MediaMessageVideo__icon-container-a43b14`,
	"iconContainer": `MediaMessageVideo__icon-container-a43b14`,
	"icon": `MediaMessageVideo__icon-bfc0be`
};
module.exports = ___CSS_LOADER_EXPORT___;
